<template>
  <v-dialog v-model="visible"
            persistent
            :max-width="'50%'">
    <v-card v-if="itemDetail">
      <v-card-title>{{title}}</v-card-title>
      <v-card-text>
        <v-layout v-for="col in getDialogKeys" :key="col.value">
          <v-flex>
            <v-switch v-if="col.value === 'hidden'"
                      v-model="itemDetail[col.value]"
                      :label="col.text"
            ></v-switch>
            <v-menu v-else-if="col.value === 'startDate' || col.value === 'endDate'"
                ref="menu"
                v-model="col.menu"
                :return-value="itemDetail[col.value]"
                transition="scale-transition"
                offset-y
                min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="itemDetail[col.value]"
                    :label="col.text"
                    :color="Theme.GREEN"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="itemDetail[col.value]"
                  :header-color="Theme.GREEN"
                  :color="Theme.GREEN"
                  no-title
                  scrollable>
              </v-date-picker>
            </v-menu>
            <v-select v-else-if="col.options"
                      :color="Theme.GREEN"
                      :items="col.options"
                      :label="col.text"
                      item-text="value" item-value="key"
                      v-model="itemDetail[col.value]"/>
            <v-select v-else-if="col.value === 'productId'"
                      :color="Theme.GREEN"
                      :items="products"
                      :label="col.text"
                      item-text="productName" item-value="productId"
                      v-model="itemDetail[col.value]"/>
            <v-text-field v-else v-model="itemDetail[col.value]"
                          :label="col.text"
                          :color="Theme.GREEN"></v-text-field>
            <img style="width: 25%;" v-if="col.isImage" :src="itemDetail[col.value]" />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-text-field v-if="itemDetail.enableType === 2" v-model="itemDetail.link"
                        :label="'自訂連結'"
                        :color="Theme.GREEN"></v-text-field>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="showCancel" :color="Theme.PINK" dark @click="cancelEvent">取消</v-btn>
        <v-spacer></v-spacer>
        <v-btn dark :color="Theme.GREEN" :loading="saveLoading" @click="confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from "@/mixins/common";
import {mapActions} from 'vuex';
import { getCurrentDate, addDayFormat } from "@/utils/tools";
export default {
  name: "news_detail",
  mixins: [common],
  props: {
    title:String,
    itemDetail: Object,
    visible: Boolean,
    showCancel: Boolean,
  },
  data() {
    return {
      saveLoading: false,
      menu: false,
      products: [],
    };
  },
  created() {
    // this.loadProductData();
  },
  mounted() {
  },
  computed: {
    getDialogKeys() {
      return [
        {value: 'name', text: '標題'},
        {value: 'hidden', text: '是否隱藏'},
        {value: 'sort', text: '排序'},
        {value: 'sURL', text: '小圖>1280*', isImage: true},
        {value: 'lURL', text: '大圖>1920*', isImage: true},
        {value: 'sURLTh', text: '小圖>1280*_泰語版本', isImage: true},
        {value: 'lURLTh', text: '大圖>1920*_泰語版本', isImage: true},
        {value: 'startDate', text: '放置開始時間' , menu: false},
        {value: 'endDate', text: '放置結束時間' , menu: false},
        {value: 'type', text: '類型*', options: this.getBannerTypeList},
        {value: 'link', text: '連結網址或商品編號'},
      ];
    },
  },
  methods: {
    ...mapActions(['saveHomeInfo','getAllProductList']),
    async loadProductData(){
      const res = await this.getAllProductList({});
      const result = res.data;
      console.log(`getAllProductList ${JSON.stringify(result)}`);
      this.products = result.body.list;
      this.$forceUpdate();
    },
    cancelEvent() {
      this.$emit('cancelEvent');
    },
    async confirmEvent() {

      if (this.itemDetail.name === '') {
        this.showMessageDialog('錯誤', '請輸入標題');
        return;
      }

      if (this.itemDetail.sURL === '') {
        this.showMessageDialog('錯誤', '請填入小圖網址');
        return;
      }

      if (this.itemDetail.lURL === ''){
        this.showMessageDialog('錯誤', '請填入大圖網址');
        return;
      }

      if (this.itemDetail.startDate.indexOf(':') === -1){
        this.itemDetail.startDate = `${getCurrentDate()}`;
      }

      if (this.itemDetail.endDate.indexOf(':') === -1){
        const end = addDayFormat(60,'YYYY-MM-DD');
        this.itemDetail.endDate = `${end}`;
      }

      if (this.itemDetail.type === 0 || this.itemDetail.type === 2){
        this.itemDetail.productId = this.itemDetail.link;
      }

      this.saveLoading = true;
      console.log(`save ${JSON.stringify(this.itemDetail)}`);
      const res = await this.saveHomeInfo({ info: this.itemDetail});
      const result = res.data;
      if (result && result.statusCode === 0) {
        this.$emit('confirmEvent', this.itemDetail);
      } else {
        this.showMessageDialog('錯誤', result.message ? result.message : '儲存失敗');
      }
      this.saveLoading = false;

    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        showCancel: false,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    },
  }
}
</script>

<style scoped>

</style>
